import { render, staticRenderFns } from "./MobileOnlyAccordion.vue?vue&type=template&id=685c143d&scoped=true&"
import script from "./MobileOnlyAccordion.vue?vue&type=script&lang=ts&"
export * from "./MobileOnlyAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./MobileOnlyAccordion.vue?vue&type=style&index=0&id=685c143d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c143d",
  null
  
)

export default component.exports